export const PERMISSIONS = {
  VIEW_CUSTOMER: 'view-customer',
  VIEW_CUSTOMER_CONTACT: 'view-customer-contact',
  VIEW_AGREEMENT: 'view-agreement',
  VIEW_WALLET: 'view-wallet',
  SIMULATE_WALLET: 'simulate-wallet',
  VIEW_WALLET_REALISATION: 'view-wallet-realisation',
  VIEW_NEWSLETTER: 'view-newsletter',
  VIEW_EMPLOYEE_ACCOUNT: 'view-employee-account',
  UPDATE_EMPLOYEE_ACCOUNT: 'update-employee-account',
};
